import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { authenticateUser } from '../../../../../../store/auth';
import Spinner from '../../../../../../components/Spinner';

import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

const settleMagicTokenMutation = gql`
  mutation($Token: String!) {
    settleMagicToken(Token: $Token) {
      token
    }
  }
`;

const MagicLinkSlugsQuery = gql`
  query {
    getMagicLinkSlugs {
      trigger_pattern
      resolve_pattern
    }
  }
`;

const mapStateToProps = state => ({
  authenticatedID: state.auth.sub || null,
  authedUser: state.auth,
});

const mapDispatchToProps = {
  authenticateUser,
};

class Redirect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };

    this.handleRedirect = this.handleRedirect.bind(this);
  }

  handleRedirect(Address, Slugs) {
    const RouteBase = Address.split('-')[0];
    const RouteParams = Address.split('-').slice(1);
    const Slug = Slugs.find(Data => Data.trigger_pattern === RouteBase);

    if (typeof Slug === 'undefined') {
      this.setState({
        error: '404 - Unsure where to redirect',
      });
    } else {
      const URL = RouteParams.reduce(
        (sum, value, index) => sum.replace('[' + index + ']', value),
        Slug.resolve_pattern,
      );
      browserHistory.push(URL);
    }
  }

  componentWillReceiveProps(nextProps) {
    // handle redirect
    if (this.props !== nextProps && this.state.error === null) {
      if (nextProps.MagicLinkSlugs.loading === false) {
        if (
          Object.prototype.hasOwnProperty.call(nextProps.params, 'Address') &&
          Object.prototype.hasOwnProperty.call(nextProps.params, 'Token')
        ) {
          nextProps
            .exchangeMagicToken({
              variables: {
                Token: nextProps.params.Token,
              },
            })
            .then(result => {
              console.log('result', result, nextProps);
              nextProps.authenticateUser(result.data.settleMagicToken.token);
              this.handleRedirect(
                nextProps.params.Address,
                nextProps.MagicLinkSlugs.getMagicLinkSlugs,
              );
            })
            .catch(err => {
              console.log(err);
              this.setState({
                error: err.graphQLErrors ? err.graphQLErrors[0]['message']: [],
              });
            });
        } else {
          this.setState({
            error: 'Invalid token',
          });
        }
      }
    }
  }

  render() {
    return (
      <div className="container">
        <div className="page-layout__viewport">
          {this.state.error === null ? (
            <Spinner />
          ) : (
            <p style={{ color: 'red', textAlign: 'center' }}>
              {this.state.error}
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default compose(
  graphql(settleMagicTokenMutation, {
    name: 'exchangeMagicToken',
  }),
  graphql(MagicLinkSlugsQuery, {
    name: 'MagicLinkSlugs',
  }),
)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Redirect),
);



// WEBPACK FOOTER //
// ./src/routes/magic/routes/SettleMagicLinkRoute/components/Redirect/index.js